import { render, staticRenderFns } from "./ContraloriaIndex.vue?vue&type=template&id=7233496b&"
import script from "./ContraloriaIndex.vue?vue&type=script&lang=js&"
export * from "./ContraloriaIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports